import { LogOut, User } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useUser } from '@/hooks/queries/use-user';
import { useAuth } from '@/providers/AuthProvider';

export const UserProfile = () => {
  const { logout } = useAuth();
  const { data: user, isLoading } = useUser();

  if (isLoading) {
    return (
      <div className="flex items-center gap-2 rounded-md p-2">
        <div className="size-9 animate-pulse rounded-full bg-muted" />
        <div className="h-4 w-24 animate-pulse rounded bg-muted group-data-[collapsible=icon]:hidden" />
      </div>
    );
  }

  if (!user) {
    return null;
  }

  const name = user.organizationUser
    ? `${user.organizationUser.givenName} ${user.organizationUser.lastName}`
    : (user.name ?? '');
  const email = user.organizationUser?.email ?? user.email ?? '';
  const avatar = typeof user.picture === 'string' ? user.picture : undefined;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="flex w-full items-center gap-2.5 rounded-md p-2 text-left hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus:bg-sidebar-accent focus:text-sidebar-accent-foreground focus:outline-none group-data-[collapsible=icon]:size-9 group-data-[collapsible=icon]:justify-center group-data-[collapsible=icon]:p-0"
          type="button"
        >
          {avatar ? (
            // biome-ignore lint/performance/noImgElement: user avatar image
            <img alt={name} className="size-9 flex-shrink-0 rounded-full object-cover" src={avatar} />
          ) : (
            <div className="flex size-9 flex-shrink-0 items-center justify-center rounded-full bg-sidebar-primary text-sidebar-primary-foreground">
              <User className="size-4" />
            </div>
          )}
          <div className="flex min-w-0 flex-1 flex-col text-sm group-data-[collapsible=icon]:hidden">
            <div className="truncate font-body font-medium">{name}</div>
            <div className="truncate text-muted-foreground text-xs">{email}</div>
          </div>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="min-w-60 bg-card text-card-foreground" side="top" sideOffset={8}>
        <div className="px-2 py-1.5">
          <p className="truncate font-medium text-sm">{name}</p>
          <p className="truncate text-muted-foreground text-xs">{email}</p>
        </div>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          className="flex items-center gap-2.5 text-destructive-strong focus:text-destructive-strong"
          onClick={() => void logout()}
        >
          <LogOut className="!text-destructive-strong size-4" />
          <span>Logout</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
